import '@babel/polyfill'
import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store/store.js'
import i18n from './i18n'
import { mapActions } from 'vuex'
// eslint-disable-next-line
// import WebSockets from './websockets/store.js'
import VeeValidate from 'vee-validate'
// eslint-disable-next-line
import printJS from 'print-js'
import XLSX from 'xlsx'
// eslint-disable-next-line
import swal from 'sweetalert'
import VideoBg from 'vue-videobg'
import confirmDeletion from './views/_partials/AppDeleteConfirmation'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import '@mdi/font/css/materialdesignicons.css'
import '@fortawesome/fontawesome-free/css/all.css'
import VueHtmlToPaper from 'vue-html-to-paper'

import axios from 'axios'
import VueAxios from 'vue-axios'
import baseURLs from './baseURLs.json'
import './filters.js'
import jquery from 'jquery'
global.jQuery = jquery
global.$ = jquery

const options = {
  name: '_blank',
  specs: ['fullscreen=yes', 'titlebar=yes', 'scrollbars=yes'],
  styles: ['/assets/css/style.css']
}
Vue.use(VueHtmlToPaper, options)

Vue.config.productionTip = false
Vue.config.performance = true

Vue.router = router

Vue.use(VueAxios, axios)
Vue.axios.defaults.baseURL = baseURLs.base
store.dispatch('misc/setBaseUrls', baseURLs)

Vue.use(require('@websanova/vue-auth'), {
  auth: require('@websanova/vue-auth/drivers/auth/bearer.js'),
  http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  fetchData: { url: 'auth/me', method: 'post', enabled: true },
  refreshData: {
    url: 'auth/refresh',
    method: 'post',
    enabled: true,
    interval: 60
  },
  logoutData: {
    url: 'auth/logout',
    method: 'POST',
    redirect: '/login',
    makeRequest: true
  },
  tokenStore: ['localStorage', 'cookie']
})

Vue.use(VeeValidate)
Vue.use(require('vue-moment'))
Vue.XLSX = XLSX

// global delete modal, no need to import it just include it like this:
// <confirm-deletion :deleteDialog="deleteDialog" @hidemodal="deleteDialog = false" @confirm="..delete action.." />
Vue.component('confirm-deletion', confirmDeletion)
Vue.component('video-bg', VideoBg)

export const mixin = {
  methods: {
    ...mapActions({
      setAppBarTitle: 'dashboard/setAppBarTitle'
    })
  }
}

Vue.mixin(mixin)

export default new Vue({
  router,
  store,
  i18n,
  printJS,
  render: h => h(App)
}).$mount('#app')
